import React, {
  FunctionComponent,
} from 'react';
import { Box, Flex } from 'rebass/styled-components';
import {
  FeatureGate,
  Heading, HorizontalRule,
} from '..';
import {
  AuthInfoCard, CollapsibleCredentials, MasterToken, MavenApiKey, UserIntegrationCredentials,
} from '.';
import { useAppState } from '../../hooks';

const copyText = require('./copy-text.json');

const { CREDENTIAL_SECTION_TITLE_USER_INTEGRATION, CREDENTIAL_SECTION_TITLE_V1 } = copyText;

const DeveloperKeysV2: FunctionComponent<{}> = () => (
  <Box>
    <Box mb={5}>
      <Heading>API Authorization</Heading>
    </Box>

    <HorizontalRule />

    <Flex mt={5}>
      <Box flex={2}>
        <Box mb={6}>
          <MasterToken />
        </Box>
        <Box mb={6}>
          <HorizontalRule />
          <CollapsibleCredentials
            trigger={CREDENTIAL_SECTION_TITLE_USER_INTEGRATION}
            credentialType="user-integration"
            content={(
              <UserIntegrationCredentials />
              )}
          />
        </Box>
        <FeatureGate feature="maven.feature.isMigratedCcsV2">
          <Box>
            <HorizontalRule />
            <CollapsibleCredentials
              trigger={CREDENTIAL_SECTION_TITLE_V1}
              credentialType="maven-api-key"
              content={(
                <Box mt={5}>
                  <MavenApiKey />
                </Box>
                )}
            />
          </Box>
        </FeatureGate>
      </Box>
      <Box flex={1} minWidth="300px" maxWidth="400px" pl={4}>
        <AuthInfoCard />
      </Box>
    </Flex>
  </Box>
);

export default DeveloperKeysV2;
